import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=cd00d7fe&"
import script from "./Assessment.vue?vue&type=script&lang=js&"
export * from "./Assessment.vue?vue&type=script&lang=js&"
import style0 from "./Assessment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports